// Recently Viewed Products Functionality
(function() {
    'use strict';
    
    ('Recently viewed script loaded');
    
    // Check if we're on a product page
    if (window.location.pathname.includes('/products/')) {
        ('On product page, attempting to add product to recently viewed');
        
        // Wait for the page to fully load to ensure product data is available
        document.addEventListener('DOMContentLoaded', function() {
            try {
                // Try to get product data from meta tags or other sources
                const productId = document.querySelector('meta[property="og:url"]')?.content?.split('/products/')?.[1]?.split('?')?.[0];
                const productTitle = document.querySelector('meta[property="og:title"]')?.content;
                const productImage = document.querySelector('meta[property="og:image"]')?.content;
                const productUrl = window.location.href;
                
                if (productId && productTitle) {
                    const currentProduct = {
                        id: productId,
                        title: productTitle,
                        url: productUrl,
                        image: productImage || 'https://via.placeholder.com/400x400/f5f5f5/999999?text=No+Image',
                        price: '$0.00' // We'll get this from the page if available
                    };
                    
                    // Try to get price from the page
                    const priceElement = document.querySelector('[data-product-price], .product-price, .price');
                    if (priceElement) {
                        currentProduct.price = priceElement.textContent.trim();
                    }
                    
                    // Add current product to recently viewed
                    addToRecentlyViewed(currentProduct);
                    ('Product added to recently viewed:', currentProduct);
                } else {
                    ('Could not extract product data from page');
                }
            } catch (error) {
                ('Error adding product to recently viewed:', error);
            }
        });
    }
    
    function addToRecentlyViewed(product) {
        try {
            let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
            
            // Remove if already exists (to avoid duplicates)
            recentlyViewed = recentlyViewed.filter(p => p.id !== product.id);
            
            // Add to beginning of array
            recentlyViewed.unshift(product);
            
            // Keep only last 6 products
            if (recentlyViewed.length > 6) {
                recentlyViewed = recentlyViewed.slice(0, 6);
            }
            
            // Save to localStorage
            localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewed));
            ('Recently viewed products saved:', recentlyViewed);
        } catch (error) {
            ('Error saving to recently viewed:', error);
        }
    }
    
    // Function to load and display recently viewed products
    window.loadRecentlyViewedProducts = function() {
        try {
            const container = document.getElementById('recently-viewed-dynamic');
            if (!container) {
                ('Recently viewed container not found');
                return;
            }
            
            const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
            ('Loading recently viewed products:', recentlyViewed);
            
            if (recentlyViewed.length === 0) {
                container.innerHTML = '<div style="text-align: center; color: #999; padding: 40px;">No recently viewed products yet.</div>';
                return;
            }
            
            let html = '';
            recentlyViewed.forEach(product => {
                html += `
                    <div class="recently-viewed-item">
                        <a href="${product.url}">
                            <img src="${product.image}" 
                                 alt="${product.title}" 
                                 class="recently-viewed-image"
                                 width="282" height="282">
                        </a>
                    </div>
                `;
            });
            
            container.innerHTML = html;
            
            // Force a reflow to ensure styles are applied
            container.offsetHeight;
        } catch (error) {
            ('Error loading recently viewed products:', error);
        }
    };
    
    // Test function - you can call this from browser console to test
    window.testRecentlyViewed = function() {
        const testProduct = {
            id: 123456,
            title: 'Test Product',
            url: '/products/test-product',
            image: 'https://via.placeholder.com/400x400/007E9A/FFFFFF?text=Test+Product',
            price: '$99.99'
        };
        addToRecentlyViewed(testProduct);
        loadRecentlyViewedProducts();
        ('Test product added!');
    };
    
    // Load recently viewed products when DOM is ready
    document.addEventListener('DOMContentLoaded', function() {
        // Check if we're on a page with the recently viewed section
        const container = document.getElementById('recently-viewed-dynamic');
        if (container) {
            ('Recently viewed section found, loading products...');
            loadRecentlyViewedProducts();
        }
    });
    
})(); 